import React from 'react';
import PropTypes from 'prop-types';

import { AddFilterActionBtn } from '.';

export default function LineWithHover(props) {
  const { index, showAddFilter = true, showAddAction = true } = props;
  return (
    <div className="position-relative d-flex justify-content-center">
      <div
        className={`line-container position-relative mx-auto`}
        style={{
          width: '2px',
          height: '40px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          backgroundColor: '#d1d1d1',
          margin: '6px auto',
        }}
      >
        <div
          className="hover-buttons position-absolute top-50 start-50 translate-middle d-flex gap-2"
          style={{
            opacity: 0,
            transform: 'translate(-50%, -50%) scale(0.8)',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap',
          }}
        >
          <AddFilterActionBtn {...{ showAddFilter, showAddAction, index }} />
        </div>
      </div>
    </div>
  );
}

LineWithHover.propTypes = {
  index: PropTypes.number,
  showAddFilter: PropTypes.bool,
  showAddAction: PropTypes.bool,
};
